import React from 'react';

import { FaRegClock } from 'react-icons/fa6';
import { FaCheck } from 'react-icons/fa';
import { AiOutlineWarning } from 'react-icons/ai';

import { useNewRefuel } from '../../../hooks/useNewRefuel';

import { Container, StatusWrap, InfosWrap, BaseName, Address } from './styles';

type BaseSelectedProps = {
  baseName: string;
  nickName: string;
  address: string;
  isSelected?: boolean;
  isComplete?: boolean;
  isError?: boolean;
};

const BaseSelected: React.FC<BaseSelectedProps> = ({
  baseName,
  address,
  nickName,
  isSelected,
  isComplete,
  isError,
}) => {
  const { handleSelectedBase } = useNewRefuel();

  return (
    <Container
      isSelected={isSelected}
      onClick={() => handleSelectedBase(baseName)}
    >
      <StatusWrap>
        {!isError && (
          <>
            {isComplete ? (
              <FaCheck size={24} color={isSelected ? '#0b29fb' : '#3d3d3d'} />
            ) : (
              <FaRegClock
                size={24}
                color={isSelected ? '#0b29fb' : '#3d3d3d'}
              />
            )}
          </>
        )}
        {isError && <AiOutlineWarning size={24} color="#E74141" />}
      </StatusWrap>
      <InfosWrap>
        <BaseName isSelected={isSelected}>{nickName}</BaseName>
        <Address>{address}</Address>
      </InfosWrap>
    </Container>
  );
};

BaseSelected.defaultProps = {
  isSelected: false,
  isComplete: false,
  isError: false,
};

export default BaseSelected;
